import React from 'react';
import './BankingIntro.css';
import bankingImage from '../../assets/images/banking.jpeg'; 

const BankingIntro = () => {
  return (
    <section className="banking-intro-section">
      <div className="container">
        <div className="banking-intro-grid">
          <div className="banking-image-container">
            <img 
              src={bankingImage} 
              alt="Banking" 
              className="banking-image"
            />
          </div>
          <div className="banking-text-content">
            <h2 className="banking-title">Our Core Banking Services</h2>
            <p>
              SAP offers various solutions for banking processes that streamline operations, improve customer experience, and ensure regulatory compliance. By integrating these solutions, banks can optimize their processes, enhance customer satisfaction, manage risks, and remain compliant with regulations. Below are key SAP tools and solutions used in banking.
            </p>
            <p>
              Neuroverse AI offers comprehensive SAP consulting services tailored to the banking sector in the UAE and the USA. Our expertise includes SAP AI and ML services designed to enhance operational efficiency and customer experience. We provide SAP consulting for banking transformation, assisting financial institutions in modernizing their operations. Our SAP banking technology and automation solutions streamline processes, ensuring seamless integration and improved service delivery. We offer SAP banking solutions in the UAE, addressing the unique needs of the regional market. Additionally, our SAP AI solutions for the banking industry leverage advanced technologies to drive innovation and competitive advantage.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BankingIntro;
